// Checkbox glyphs for the brand theme: a rounded square, filled ink when checked.
// Sizes and colours are set by the MuiCheckbox overrides through the brand-checkbox classes.
const Tick = () => (
  <svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true">
    <path d="M3.5 8.5l3 3 6-6.5" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const Dash = () => (
  <svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true">
    <path d="M4 8h8" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
  </svg>
);

export const checkboxIcon = <span className="brand-checkbox" />;
export const checkboxCheckedIcon = (
  <span className="brand-checkbox brand-checkbox--on">
    <Tick />
  </span>
);
export const checkboxIndeterminateIcon = (
  <span className="brand-checkbox brand-checkbox--on">
    <Dash />
  </span>
);
